jQuery($ => {
    class DropdownMenu {
      constructor(element) {
        this._          = element;
        this._element   = $(element);
        this._focusables = this._element.find('button, [href], input:not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])');
        this._toggle     = this._element.closest('.u-toggle');

        this.init();
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Initialize
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      init() {
        this.setupHandlers();
        this.positionPanel();
        this._element.trigger( 'dropdown-menu:init', this );
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Setup Handlers
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      setupHandlers() {
        this._focusables.on('keydown', this.handleKeydown);
        this._toggle.on('toggle:on', this.positionPanel);
        $(window).on('resize', this.positionPanel);
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Position Panel
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      // Center the panel under its control, clamped inside the viewport
      // gutters — same approach as molecules/meganav's positionPanel.
      positionPanel = () => {
        const control = document.getElementById(this._element.data('controlledby'));

        if (!control) return;

        const $offsetParent = this._element.offsetParent();
        const parentRect    = $offsetParent.length ? $offsetParent[0].getBoundingClientRect() : { left: 0 };
        const controlRect   = control.getBoundingClientRect();
        const half          = this._element.outerWidth() / 2;
        const gutter        = 30;
        const center        = controlRect.left + controlRect.width / 2;
        const clamped       = Math.min(Math.max(center, half + gutter), window.innerWidth - half - gutter);

        this._element.css('--toggle-target-x-position', `${clamped - parentRect.left}px`);
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Handle Keydown
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      handleKeydown = (event) => {
        const index     = this._focusables.index(event.currentTarget);
        const lastIndex = this._focusables.length - 1;

        switch (event.key) {
          case 'ArrowUp':
            event.preventDefault();

            const prevIndex = !index ? lastIndex : index - 1;
            this._focusables.eq(prevIndex).focus();
            break;

          case 'ArrowDown':
            event.preventDefault();

            const nextIndex = index === lastIndex ? 0 : index + 1;
            this._focusables.eq(nextIndex).focus();
            break;
        }
      }
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Setup jQuery Plugin
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    $.fn.dropdownMenu = function() {
      var _ = this,
          opt = arguments[0],
          args = Array.prototype.slice.call(arguments, 1),
          l = _.length,
          i,
          ret;
      for (i = 0; i < l; i++) {
        if (typeof opt == 'object' || typeof opt == 'undefined')
          _[i].dropdownMenu = new DropdownMenu(_[i], opt);
        else
          ret = _[i].dropdownMenu[opt].apply(_[i].dropdownMenu, args);
        if (typeof ret != 'undefined') return ret;
      }
      return _;
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Run
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    $('.m-dropdown-menu').dropdownMenu();
});
